import { makeStyles } from 'tss-react/mui'
import PlayerDecoBottom from '@/assets/img/player-deco-bottom.svg'
import PlayerDecoTop from '@/assets/img/player-deco-top.svg'

import { colors } from '@/theme/colors.theme'

export const useStyles = makeStyles()(() => {
  return {
    summary: {
      width: 326,
      background: `linear-gradient(173deg, ${colors.dark} 0%, ${colors.darker} 100%)`,
      position: 'sticky',
      left: 0,
      padding: '0 24px',
      '&::before': {
        content: '""',
        backgroundImage: `url(${PlayerDecoTop})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPositionY: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 326,
        zIndex: -1,
      },
      '&::after': {
        content: '""',
        backgroundImage: `url(${PlayerDecoBottom})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPositionY: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 326,
      },
    },
  }
})
